export default __webpack_public_path__ + "static/media/main2.0f1db66a.png";